import post from '../utils/post'
export const baseURL="http://www.wanbaoe.cn:9981/insurance"
// export const baseURL="http://47.112.219.35:9981/insurance"

export function motobaoGetPayUrl(price) {
    return post(baseURL,'motoci/13/motobaoGetPayUrl',{price:price})
}